// Menù Dal Conte — Pizzeria di Campagna
// Le voci con "frozen: true" indicano prodotto surgelato (*)

export const PIZZE = [
  {
    id: "tradizionali",
    number: "01",
    title: "Tradizionali",
    subtitle:
      "I grandi classici della pizza italiana. Gusti intramontabili e semplicità assoluta.",
    items: [
      { name: "Margherita", ingredients: "pomodoro, mozzarella", price: "7,00" },
      { name: "Marinara", ingredients: "pomodoro, olio all'aglio, origano", price: "6,50" },
      { name: "Napoletana", ingredients: "pomodoro, mozzarella, acciughe, origano", price: "8,00" },
      { name: "Bufala", ingredients: "pomodoro, mozzarella di bufala campana", price: "9,50" },
      { name: "Salamino", ingredients: "pomodoro, mozzarella, salamino piccante", price: "9,00" },
      { name: "Pugliese", ingredients: "pomodoro, mozzarella, cipolle, grana padano", price: "9,00" },
      { name: "Prosciutto & Funghi", ingredients: "pomodoro, mozzarella, prosciutto cotto, funghi", price: "9,50" },
      { name: "Capricciosa", ingredients: "pomodoro, mozzarella, prosciutto cotto, funghi, carciofi", price: "10,00" },
      { name: "Tonno & Cipolle", ingredients: "pomodoro, mozzarella, tonno, cipolle", price: "10,00" },
      { name: "Verdure", ingredients: "pomodoro, mozzarella, zucchine, peperoni, melanzane", price: "10,50" },
      { name: "Wurstel & Patatine", ingredients: "pomodoro, mozzarella, wurstel, patatine", price: "10,50", frozen: true },
      { name: "Quattro Formaggi", ingredients: "pomodoro, mozzarella, gorgonzola, brie, grana padano", price: "11,00" },
      { name: "Speck & Brie", ingredients: "pomodoro, mozzarella, speck, brie", price: "11,50" },
      { name: "Vesuvio", ingredients: "pomodoro, mozzarella di bufala campana, pomodorini, rucola", price: "11,50" },
      { name: "Sandrino", ingredients: "pomodoro, mozzarella di bufala campana, salamino piccante, gorgonzola", price: "12,00" },
    ],
  },
  {
    id: "signature",
    number: "02",
    title: "Signature",
    subtitle:
      "Le nostre pizze esclusive: ingredienti top e abbinamenti originali per un'esperienza gourmet unica.",
    items: [
      { name: "Trentina", ingredients: "pomodoro, mozzarella, speck, gorgonzola, funghi", price: "12,00" },
      { name: "Regina", ingredients: "mozzarella, brie, noci, speck, miele", price: "12,50" },
      { name: "Mediterranea", ingredients: "pomodoro, mozzarella di bufala, crudo di Parma 24 mesi, pomodorini, rucola", price: "12,50" },
      { name: "Nebbia", ingredients: "mozzarella, gorgonzola, brie, grana padano, funghi porcini, salsiccia", price: "13,00" },
      { name: "Della Casa", ingredients: "pomodoro, mozzarella di bufala campana, crudo di Parma 24 mesi, porcini", price: "14,00" },
      { name: "Olga", ingredients: "pomodoro, mozzarella, basilico, crudo, pomodori secchi, stracciatella", price: "14,00" },
      { name: "Parmense", ingredients: "pomodoro, mozzarella, crudo di Parma 24 mesi, scamorza affumicata, funghi porcini", price: "14,00" },
      { name: "Crudo & Burrata", ingredients: "pomodoro, mozzarella, burrata, crudo di Parma 24 mesi", price: "14,00" },
      { name: "Fioccata", ingredients: "pomodoro, mozzarella, burrata, fiocchetto, rucola", price: "14,00" },
      { name: "Spako Oss", ingredients: "pomodoro, mozzarella, gorgonzola, salamino piccante, acciughe, cipolle, capperi, peperoni", price: "14,00" },
    ],
  },
  {
    id: "territorio",
    number: "03",
    title: "Territorio",
    subtitle:
      "Pizze ispirate alle tradizioni culinarie locali e arricchite dalle eccellenze dei produttori vicini a noi.",
    items: [
      { name: "Martinengo", ingredients: "mozzarella, gorgonzola piccante, miele, noci", price: "10,50" },
      { name: "Mantovana", ingredients: "crema di zucca, mozzarella, salsiccia, gorgonzola", price: "10,50" },
      { name: "Bresciana", ingredients: "pomodoro, mozzarella, salamino piccante, gorgonzola", price: "11,00" },
      { name: "Carciofa", ingredients: "pomodoro, mozzarella, carciofi alla romana, fiocchetto", price: "11,50" },
      { name: "Dal Conte", ingredients: "pomodoro, mozzarella, carciofi alla romana, pomodori secchi, salsiccia", price: "12,50" },
      { name: "Selvatica", ingredients: "crema di zucca, mozzarella, salsiccia, porcini, pecorino", price: "13,00" },
    ],
  },
];

export const ALTRO = [
  {
    id: "burger",
    number: "04",
    title: "Burger",
    subtitle:
      "Carne selezionata e cottura alla piastra, accompagnata da patatine fritte morbide dentro e croccanti fuori.",
    items: [
      { name: "Classic", ingredients: "doppio smash, cheddar, lattuga, cipolla caramellata, cetriolini e salsa burger", price: "15,00" },
      { name: "Bacon Spicy", ingredients: "doppio smash, cheddar, bacon croccante, jalapeños, cipolla caramellata e salsa piccante", price: "15,00" },
      { name: "Chicken", ingredients: "chicken burger croccante da 200 g, lattuga, pomodoro, scaglie di grana e salsa Caesar", price: "15,00" },
      { name: "Mediterraneo", ingredients: "doppio smash, burrata di bufala, pomodori semi-dry e pesto al basilico", price: "15,00" },
    ],
  },
  {
    id: "fritti",
    number: "05",
    title: "Fritti",
    subtitle: "Croccanti, dorati e irresistibili. L'inizio perfetto.",
    items: [
      { name: "Patatine Fritte", ingredients: "", price: "5,00", frozen: true },
      { name: "Jalapeño Ripieni di Formaggio", ingredients: "", price: "7,00", frozen: true },
      { name: "Straccetti di Pollo", ingredients: "", price: "7,00", frozen: true },
    ],
  },
];

export const DRINKS = [
  {
    id: "birra",
    number: "06",
    title: "Birra",
    groups: [
      {
        label: "Alla spina",
        items: [
          { name: "Ayinger Lager Hell", ingredients: "Helles · Germania · 4,9%", price: "0,3 lt 3,50 · 0,5 lt 5,00" },
          { name: "Ayinger Celebrator", ingredients: "Doppelbock · Germania · 6,7%", price: "0,3 lt 3,50 · 0,5 lt 5,00" },
        ],
      },
      {
        label: "In bottiglia",
        items: [
          { name: "Ayinger Brauweisse", ingredients: "Weissbier · Germania · 5,1% · 0,5 lt", price: "6,00" },
          { name: "Augustiner Lagerbier Hell", ingredients: "Helles · Germania · 5,2% · 0,5 lt", price: "6,00" },
          { name: "Landshuter Hell Alkoholfrei", ingredients: "Helles analcolica · Germania · 0,0% · 0,5 lt", price: "5,00" },
          { name: "Daura Damm Gluten Free", ingredients: "Lager senza glutine · Spagna · 5,4% · 0,33 lt", price: "5,00" },
        ],
      },
      {
        label: "In lattina",
        items: [
          { name: "Eight Degrees Citra IPA", ingredients: "Single Hop IPA · Irlanda · 5,7% · 0,44 lt", price: "6,00" },
        ],
      },
    ],
  },
  {
    id: "vino",
    number: "07",
    title: "Vino",
    groups: [
      {
        label: "Bollicine",
        items: [
          { name: "Prosecco Superiore Valdobbiadene DOCG Extra Dry \u201CPietraluna\u201D", ingredients: "Millesimato", price: "Calice 4,00 · Bott. 20,00" },
          { name: "Franciacorta Brut DOCG \u201CAlma\u201D — Bellavista", ingredients: "", price: "Bott. 50,00" },
          { name: "Franciacorta Brut DOCG \u201CCola Battista\u201D", ingredients: "", price: "Bott. 35,00" },
          { name: "Crémant d'Alsace AOC Brut \u201CAllimant-Laugner\u201D", ingredients: "", price: "Bott. 30,00" },
        ],
      },
      {
        label: "Bianchi & Frizzanti",
        items: [
          { name: "Lugana DOC \u201CEufrasia\u201D — Sgreva", ingredients: "", price: "Calice 4,00 · Bott. 25,00" },
          { name: "Ortrugo Frizzante Colli Piacentini DOC — Costa Binelli", ingredients: "", price: "Calice 3,50 · Bott. 15,00" },
          { name: "Chardonnay del Garda — Az. Agr. Averoldi", ingredients: "", price: "Bott. 15,00" },
          { name: "Valtenesi Chiaretto DOC — Az. Agr. Averoldi", ingredients: "", price: "Bott. 15,00" },
        ],
      },
      {
        label: "Rossi",
        items: [
          { name: "Valpolicella Ripasso Superiore DOC — Val Parajso", ingredients: "", price: "Calice 5,00 · Bott. 25,00" },
        ],
      },
    ],
  },
];

export const NOTES = [
  {
    title: "Dessert",
    text: "Lasciatevi guidare alla scoperta dei nostri dessert: il personale di sala è a vostra disposizione per consigliarvi.",
  },
  {
    title: "Bibite",
    text: "In lattina, 3,50 € ciascuna — Aranciata San Pellegrino, Estathé limone o pesca, Tonica Schweppes, Coca-Cola, Coca-Cola Zero, Sprite, Lemonsoda.",
  },
];
